import ProductPageLayout, { ProductPageConfig } from "@/components/products/ProductPageLayout";
import filmAlu from "@/assets/products/film-alu.png";

const config: ProductPageConfig = {
  name: "Film aluminium",
  breadcrumbName: "Film aluminium",
  subtitle: "Rouleau de film aluminium professionnel pour la cuisson, conservation et emballage",
  features: ["Contact alimentaire", "Résistant à la chaleur", "Professionnel", "Disponible en stock"],
  variants: [
    { name: "Film aluminium 30cm x 300m", dimensions: "30 cm x 300 m", material: "Aluminium", packaging: "Carton de 6 rouleaux", palette: "336 cartons", image: filmAlu },
  ],
};

const FilmAluminium = () => <ProductPageLayout config={config} />;
export default FilmAluminium;
